import { render, staticRenderFns } from "./PodrEdit.vue?vue&type=template&id=3a736080&scoped=true&"
import script from "./PodrEdit.vue?vue&type=script&lang=js&"
export * from "./PodrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a736080",
  null
  
)

export default component.exports